import { render, staticRenderFns } from "./ProjectWheel.vue?vue&type=template&id=fca4ef08&scoped=true&"
import script from "./ProjectWheel.vue?vue&type=script&lang=js&"
export * from "./ProjectWheel.vue?vue&type=script&lang=js&"
import style0 from "./ProjectWheel.vue?vue&type=style&index=0&id=fca4ef08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca4ef08",
  null
  
)

export default component.exports